import { render } from "./PlatformPage.vue?vue&type=template&id=0b68be7e"
import script from "./PlatformPage.vue?vue&type=script&lang=js"
export * from "./PlatformPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__